import { action } from 'mobx';
import { ProcedureCodeEditForm } from 'application/procedure-code/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ProcedureCodeService } from 'application/product/services';

@applicationContext
class ProcedureCodeEditViewStore extends BaseEditViewStore {

    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const procedureCodeService = new ProcedureCodeService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'procedure-code-edit',
            id: id,
            Form: ProcedureCodeEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, options) => {
                        const response = await procedureCodeService.get(id, options);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await procedureCodeService.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await procedureCodeService.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ProcedureCodeEditForm,
        });
    }
    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success("PROCEDURE_CODE.EDIT.SUCCESS"), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Procedure Code already exists.' : err.data.message : `Error occurred while trying to update a Procedure Code.`
                );
            }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create({
                ...resource
            });
           
            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() =>  this.rootStore.notificationStore.success("PROCEDURE_CODE.CREATE.SUCCESS"), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
            err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Procedure Code already exists.' : err.data.message : `Error occurred while trying to update a Procedure Code.`
            );
        }
    }
}

export default ProcedureCodeEditViewStore;
